import classNames from 'classnames'

import { Content } from '../../Modal'

import * as styles from './TableModalContent.module.css'

function TableModalContent(props) {
  const {
    className = styles.tableModalContent,
    contentWrapperClassName = styles.tableModalContentWrapper,
    loading,
    noData,
    ...contentProps
  } = props

  return (
    <Content
      {...contentProps}
      className={classNames(className, {
        [styles.tableModalContentLoading]: loading,
      })}
      containerClassName={styles.container}
      contentWrapperClassName={classNames(contentWrapperClassName, {
        [styles.noData]: noData,
      })}
    >
      {props.children}
    </Content>
  )
}

export default TableModalContent
